module.exports = __webpack_public_path__ + "img/payment-page.a05005fa.png";